<p-multiSelect appendTo="body" name="{{name}}" id="id_{{name}}" [options]="options" [(ngModel)]="value" [required]="required"
       [disabled]='disabled' (onFocus)='focused($event)' (onBlur)="blured($event)" styleClass="{{class}}" [style]="style" [panelStyle]="panelStyle"
       (onChange)=" valuechange($event)" [defaultLabel]="placeholder" [filter]="filter" [showClear]="showClear" [filterBy]="filterBy">
</p-multiSelect>
